import { FC } from 'react';

import StripeIntegrationCard from './StripeIntegrationCard/StripeIntegrationCard';

interface IntegrationsPageProps {}

const IntegrationsPage: FC<IntegrationsPageProps> = () => {
  return (
    <div className="pt-2.4 pl-3 pr-4 text-14 leading-[2.1rem]">
      <h3 className="text-24 font-bold leading-[3.6rem]">Integrations</h3>
      <div className="mt-3.2">
        <StripeIntegrationCard />
      </div>
    </div>
  );
};

export default IntegrationsPage;
